import { Base64 } from 'js-base64';
export default function buy(buyCode, basicInfo, activityId) {
  const dialogContent =
    `
    <div class="dialog-config-content">
    <ul>
    <li>
      <div class="dn-row">
        <div>
          <label for="dialog-region" style="float: left">
            请选择地域：
          </label>
        </div>
        <div>
          <select id="dialog-region"style="float: left">
            <option value="cn-beijing">
              华北2
            </option>
            <option value="cn-qingdao">
              华北1
            </option>
            <option value="cn-zhangjiakou">
              华北3
            </option>
            <option value="cn-hangzhou">
              华东1
            </option>
            <option value="cn-shanghai">
              华东2
            </option>
            <option value="cn-shenzhen">
              华南1
            </option>
            <option value="cn-hongkong">
              香港
            </option>
          </select>
        </div>
      </div>
    </li>
    <li>
      <div class="dn-row">
        <div>
          <label for="dialog-imageId"style="float: left">
            请选择镜像类型：
          </label>
        </div>
        <div>
          <select id="dialog-imageId" style="width: 100%, float: left">
            <option value="centos_7_04_64_20G_alibase_201701015.vhd">
              CentOS 7.4 64位
            </option>
            <option value="win2008r2_64_ent_sp1_zh-cn_40G_alibase_20170915.vhd">
              Windows Server  2008 R2 企业版 64位中文版
            </option>
            <option value="ubuntu_16_0402_64_20G_alibase_20180409.vhd">
              Ubuntu  16.04 64位
            </option>
            <option value="win2012r2_64_dtc_17196_zh-cn_40G_alibase_20170915.vhd">
              Windows Server  2012  R2 数据中心版 64位中文版
            </option>
            <option value="cwin2008_32_std_sp2_zh-cn_40G_alibase_20170622.vhd">
              Windows Server  2008 标准版 SP2 32位中文版
            </option>
            <option value="centos_6_08_64_20G_alibase_20170824.vhd">
              CentOS 6.8 64位
            </option>
            <option value="centos_7_02_64_20G_alibase_20170818.vhd">
              CentOS 7.2 64位
            </option>
            <option value="centos_7_03_64_20G_alibase_20170818.vhd">
              CentOS 7.3 64位
            </option>
          </select>
        </div>
      </div>
    </li>
  </ul>
    </div>
    `;
  const Modal = window.DN.Modal;
  let region = ""
  let imageId = ""
  if ($(window).width() <= 768) {
    const url_ba = Base64.decode("eyJkYXRhIjp7ImFjdGl2aXR5SWQiOnsiZGVmYXVsdFZhbHVlIjoiMTgwOTA0MDg1MzU3MDM2NSJ9LCJyZWdpb25JZCI6eyJkZWZhdWx0VmFsdWUiOiJjbi1iZWlqaW5nLWJ0Yy1hMDEiLCJkZWZhdWx0RGF0YSI6WyJjbi1xaW5nZGFvLWNtNS1hMDEiLCJjbi1iZWlqaW5nLWJ0Yy1hMDEiLCJjbi16aGFuZ2ppYWtvdS1uYTYyLWEwMSIsImNuLWhhbmd6aG91LWRnLWEwMSIsImNuLXNoYW5naGFpLWV1MTMtYTAxIiwiY24tc2hlbnpoZW4tc3QzLWEwMSIsImNuLWhvbmdrb25nLWFtNC1jMDQiXX0sImluc3RhbmNlVHlwZSI6eyJkZWZhdWx0RGF0YSI6WyJlY3MudDUtbGMxbTEubGFyZ2UiLCJlY3MudDUtYzFtMi5sYXJnZSJdLCJvcHRpb25hbCI6ZmFsc2V9LCJzeXN0ZW1EaXNrIjp7Im9wdGlvbmFsIjpmYWxzZX0sImRhdGFEaXNrcyI6eyJhbHdheXNTaG93IjpmYWxzZSwib3B0aW9uYWwiOmZhbHNlfSwibmV0d29ya1R5cGUiOnsib3B0aW9uYWwiOmZhbHNlfSwiYmFuZHdpZHRoIjp7Im9wdGlvbmFsIjpmYWxzZX0sInBlcmlvZCI6eyJkZWZhdWx0RGF0YSI6WyIxWSIsIjJZIiwiM1kiXSwiZGVmYXVsdFZhbHVlIjoiM1kifSwiYW1vdW50Ijp7Im1heCI6MSwib3B0aW9uYWwiOmZhbHNlfSwiaW1hZ2VJZCI6eyJkZWZhdWx0RGF0YSI6WyJjZW50b3NfN18wNF82NF8yMEdfYWxpYmFzZV8yMDE3MDEwMTUudmhkIiwiY2VudG9zXzdfMDNfNjRfMjBHX2FsaWJhc2VfMjAxNzA4MTgudmhkIiwiY2VudG9zXzdfMDJfNjRfMjBHX2FsaWJhc2VfMjAxNzA4MTgudmhkIiwiY2VudG9zXzZfMDhfNjRfMjBHX2FsaWJhc2VfMjAxNzA4MjQudmhkIiwid2luMjAxMnIyXzY0X2R0Y18xNzE5Nl96aC1jbl80MEdfYWxpYmFzZV8yMDE3MDkxNS52aGQiLCJ3aW4yMDA4XzMyX3N0ZF9zcDJfemgtY25fNDBHX2FsaWJhc2VfMjAxNzA2MjIudmhkIiwid2luMjAwOHIyXzY0X2VudF9zcDFfemgtY25fNDBHX2FsaWJhc2VfMjAxNzA5MTUudmhkIiwidWJ1bnR1XzE2XzA0MDJfNjRfMjBHX2FsaWJhc2VfMjAxNzEyMjcudmhkIl19LCJwcm9tb3Rpb25TaG93Ijp7ImRlZmF1bHRWYWx1ZSI6ZmFsc2V9fX0=")
    let url_last = JSON.parse(url_ba)
    url_last["data"]["groupBuyCode"]= {"defaultValue": buyCode}
    const url = `https://ecs-buy.aliyun.com/mbuy?data=${Base64.encode(JSON.stringify(url_last))}`;
    location.href = url;
  } else {
    Modal.dialog({
      title: '购买确认',
      content: function makeContent() {
        const $content = $(dialogContent);
        // 设置地域默认值
        region = 'cn-beijing';
        imageId = "centos_7_04_64_20G_alibase_201701015.vhd";
        $content.find('#dialog-region').on('change', function () {
          const val = $(this).val();
          region = val;
        });
        $content.find('#dialog-imageId').on('change', function () {
          const val = $(this).val();
          imageId = val;
        });
        return $content;
      },
      button: [
        {
          text: '立即购买',
          onClick: () => {
            const url = `https://ecs-buy.aliyun.com/wizard#/prepay/${region}?instanceType=ecs.t5-c1m2.large&imageType=public&imageId=${imageId}&networkType=vpc&internetChargeType=PayByBandwidth&internetMaxBandwidthOut=1&autoRenew=false&directConfirm=true&orderSource=groupBuy&periodType=Yearly&period=${basicInfo.duration}&activityId=${activityId}&groupBuyCode=${buyCode}`;
            location.href = url;
          }
        }
      ]
    })
  }
}


// WEBPACK FOOTER //
// ./src/ecs/buy.js